module.exports = __webpack_public_path__ + "img/kika-klat-untitled.b79f486.jpg";